var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCheckmark = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.68891 12.2707C4.26265 12.2707 3.93972 12.1157 3.662 11.7863L0.329386 7.78199C0.0839612 7.50427 0 7.25885 0 6.97467C0 6.34173 0.477933 5.87672 1.12379 5.87672C1.49839 5.87672 1.76964 6.00589 2.01507 6.30298L4.66308 9.55164L9.89451 1.31052C10.1593 0.890712 10.437 0.729248 10.8762 0.729248C11.5221 0.729248 12 1.19426 12 1.82074C12 2.05325 11.929 2.30514 11.7546 2.56994L5.74166 11.7346C5.49623 12.0963 5.14747 12.2707 4.68891 12.2707Z",
    fill: "#EC691A"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCheckmark);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Checkmark.2e47d63ff450f4aef9dc4e4e1964a660.svg";